import { render, staticRenderFns } from "./CharacterSpell.vue?vue&type=template&id=6d8c18c4&"
import script from "./CharacterSpell.vue?vue&type=script&lang=js&"
export * from "./CharacterSpell.vue?vue&type=script&lang=js&"
import style0 from "./CharacterSpell.vue?vue&type=style&index=0&id=6d8c18c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports